const KEY = "bp_attrib_v1";
const TTL_MS = 30 * 24 * 3600 * 1000;
const PARAMS = ["gclid", "utm_source", "utm_medium", "utm_campaign", "utm_term"];

// Captura los parámetros de campaña de la URL y los guarda 30 días en el navegador
export function captureAttribution() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    PARAMS.forEach((k) => {
      const v = q.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length) {
      localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), params: found }));
    }
  } catch {}
}

export function getAttribution() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { ts, params } = JSON.parse(raw);
    if (Date.now() - ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return params;
  } catch {
    return null;
  }
}

// Conserva gclid/utm al navegar entre secciones de la tienda
export function withParams(path) {
  const p = getAttribution();
  if (!p) return path;
  const q = new URLSearchParams();
  Object.entries(p).forEach(([k, v]) => q.set(k, v));
  return `${path}${path.includes("?") ? "&" : "?"}${q.toString()}`;
}
